var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('img',{attrs:{"src":"/img/brand/logo-white.svg","alt":"logo loader"}}),_c('v-progress-circular',{attrs:{"size":50,"indeterminate":"","color":'#ffb511'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }